import { connectHits } from 'instantsearch.js/es/connectors';

const renderHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, results } = renderOptions;
    let themePath = $('.tematik_produits').data('theme-path');
    let defaultImg = themePath + "/img/photos/default-img.svg";
    let baseUrl = $('.tematik_produits').data('url');
    let ficheProduitUrl = $('.tematik_produits').data('fiche-produit-url');

    let checkConditionnement = (quantite, unite) => {
        if (unite === 'kg' && quantite >= 5) {
            return false;
        }
        return true;
    }
    
    widgetParams.container.innerHTML = `
        ${hits.map(item => `
            <li class="ais-InfiniteHits-item">
                <a class="blocMedia blocMedia--produit" href="${ficheProduitUrl + '/' + item.url_seo}">
                    <figure class="blocMedia-media" style="background-image: url('${themePath}/img/gravures/gravure-bg-produit.png');">
                        ${(item.illustration_principale) ? `
                            <picture>
                                ${(item.illustration_principale) ? `
                                    <source srcset="${baseUrl + item.illustration_principale.webp}" type="image/webp">
                                ` : ''}
                                <img src="${baseUrl + item.illustration_principale.base}" alt="${item.nom_produit}">    
                            </picture>
                        ` : `
                            <img src="${defaultImg}" alt="${item.nom_produit}"></img>
                        `}
                        ${item.marque_illustration ? `
                        <span class="blocMedia-logo"><img src="${baseUrl + item.marque_illustration}" alt="${item.marque}"></span>                  
                        ` : ''}
                    </figure>
                    <article class="blocMedia-contenu">
                        <h2 class="blocMedia-titre titre4--lowercase">${item.nom_produit}</h2>
                        <span class="blocMedia-categories">
                            ${item.categorie_produit} | ${item.gamme_produit}
                        </span>
                        <div class="blocMedia-attributs">
                            <span><i class="icon-weight"></i> ${item.conditionnement} ${item.unite_conditionnement}</span>
                            ${(item.nombre_de_parts && item.conditionnement_part) ? `
                                <span><i class="icon-slice"></i> ${item.nombre_de_parts} ${widgetParams.traductions.portions} ${item.conditionnement_part} ${item.unite_conditionnement_part ?? item.unite_conditionnement}</span>                            
                            ` : ''}
                        </div>
                    </article>
                </a>
            </li>`
        ).join('')}`;
    };
  
  const customHits = connectHits(renderHits);
 
  export default customHits;